import { Link } from '@mui/joy';
import { ICellRendererParams } from 'ag-grid-community';
import { Link as RouterLink } from 'react-router-dom';

import { getAgGridTableCellData } from 'core/utils';
import { pricingProfileDetailsPath } from 'pricing/routes/routePaths';

const PricingProfileCell = (props: ICellRendererParams) => {
  const data = getAgGridTableCellData(props, 'priceSourcePricingProfileName');
  if (!data) {
    return props?.value;
  }

  const { priceSourcePricingProfileId, priceSourcePricingProfileName } = data;

  return (
    <Link component={RouterLink} to={pricingProfileDetailsPath(priceSourcePricingProfileId)}>
      {priceSourcePricingProfileName}
    </Link>
  );
};

export default PricingProfileCell;
